import avatar1 from '../../assets/employeeImg/avatar.jpg'
import avatar2 from '../../assets/employeeImg/avatar2.jpg'
import avatar3 from '../../assets/employeeImg/avatar3.jpg'
import avatar4 from '../../assets/employeeImg/avatar4.jpg'
import avatar5 from '../../assets/employeeImg/avatar5.jpg'


const EmployeeData = 
[
    {
        avatar:avatar1,
        name:"Luke Short",
        userName:"@Short",
        completed:"80%"
    },
    {
        avatar:avatar2,
        name:"John Hard",
        userName:"@rdacre",
        completed:"75%"
    },
    {
        avatar:avatar3,
        name:"Rachel Parr",
        userName:"@Parr",
        completed:"70%"
    },
    {
        avatar:avatar4,
        name:"Paul Rees",
        userName:"@Rees",
        completed:"60%"
    },
    {
        avatar:avatar5,
        name:"Eric Reid",
        userName:"@Eric",
        completed:"59%"
    },
    {
        avatar:avatar1,
        name:"Jan Ince",
        userName:"@Ince",
        completed:"55%"
    },
]
export default EmployeeData;